export const isLocalRepresentativeAction = type =>
    type === 'call' || type === 'email' || type === 'tweet';

export const areLocalRepresentativeActions = actionTypes =>
    actionTypes.filter(type => isLocalRepresentativeAction(type)).length === actionTypes;
